import axios from "axios"
import moment from "moment";

import CisInsightService from "@/services/cis-insight.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetInsight {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = moment(en_dt).add(1, 'month').format('YYYY-MM')

        this.majorClsList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const firstClasses = await CisInsightService.listFirstClass({
            ctgSq: this.sel_category
        }, source);

        if (firstClasses.data.success)
            this.majorClsList = firstClasses.data.data
    }

    async run() {
        const cdj_list = ['카테고리 탐색', '속성 탐색', '구매 및 관리']

        var resDataset = [];

        var cdj_tb_data = null;

        const cdj_tb_resp = await CisInsightService.getInsightDataCDJTable({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],
            selMiddle: null, 
        }, source);

        if (cdj_tb_resp && cdj_tb_resp.status === 200) {
            cdj_tb_data = cdj_tb_resp.data.data;

            var brandFreqData = [];       

            var gen_search_freq_upper = Math.round((cdj_tb_data[0].freq + cdj_tb_data[1].freq + cdj_tb_data[2].freq)*100)/100

            brandFreqData.push({
                cdj: '카테고리 탐색',
                freq: gen_search_freq_upper
            })

            var atr_search_freq_upper = Math.round((cdj_tb_data[3].freq + cdj_tb_data[4].freq + cdj_tb_data[5].freq + cdj_tb_data[6].freq + cdj_tb_data[7].freq)*100)/100

            brandFreqData.push({
                cdj: '속성 탐색',
                freq: atr_search_freq_upper
            })

            var buy_manage_freq_upper = Math.round((cdj_tb_data[8].freq + cdj_tb_data[9].freq)*100)/100

            brandFreqData.push({
                cdj: '구매 및 관리',
                freq: buy_manage_freq_upper
            })

            var tot_search_freq_upper = Math.round((cdj_tb_data[0].freq + cdj_tb_data[1].freq + cdj_tb_data[2].freq + cdj_tb_data[3].freq + cdj_tb_data[4].freq + cdj_tb_data[5].freq + cdj_tb_data[6].freq + cdj_tb_data[7].freq + cdj_tb_data[8].freq + cdj_tb_data[9].freq)*100)/100

            brandFreqData.push({
                cdj: 'Total',
                freq: tot_search_freq_upper
            })

            resDataset.push({'sheet_type': 0, 'sheet_nm': '소비자 탐색 오버뷰_전체', 'data': brandFreqData, 'cat': ['검색량', '비율']})
        }

        for (const cdj of cdj_list) {
            const overview_resp = await CisInsightService.getInsightDataDonutBar({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                brandList : [],
                firstClassList : [],       
                cdj : cdj
            }, source);

            if (overview_resp && overview_resp.status === 200) {
                const totalFreq = overview_resp.data.data.donutData[0].totalFreq
                var brandShareData = [];

                for(const item of overview_resp.data.data.barData) {
                    brandShareData.push({
                        keyword: item.brand,
                        freq: item.freq,
                        rate: totalFreq == 0 ? 0 : item.freq / totalFreq * 100
                    });
                }

                resDataset.push({'sheet_type': 1, 'sheet_nm': `브랜드 점유율(${cdj})_전체`, 'data': brandShareData, 'cat': ['검색량', '비율']})
            }
        }

        // stacked chart category setting
        var cdjDetails = []

        for(const item of cdj_tb_data)
            cdjDetails.push(item.cdjDetails)

        const stacked_resp = await CisInsightService.getInsightDataStacked({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],
            selMiddle: null, 
            cdjDetail1 :  cdjDetails[0],
            cdjDetail2 :  cdjDetails[1],
            cdjDetail3 :  cdjDetails[2],
            cdjDetail4 :  cdjDetails[3],
            cdjDetail5 :  cdjDetails[4],
            cdjDetail6 :  cdjDetails[5],
            cdjDetail7 :  cdjDetails[6],
            cdjDetail8 :  cdjDetails[7],
            cdjDetail9 :  cdjDetails[8],
            cdjDetail10 : cdjDetails[9]
        }, source);

        if (stacked_resp && stacked_resp.status === 200) {
            // stacked chart update
            var stackChartData = []
            var stackChartCat = []
            var stackDatas = []

            for(const item of stacked_resp.data.data) {
                var keywords = item.keyword.split(',')
                var freqs = item.freq.split(',')
                var rates = item.rate.split(',')

                stackDatas = []
                stackDatas.push(keywords)
                stackDatas.push(freqs)
                stackDatas.push(rates)

                stackChartData.push(stackDatas)
            }

            stackChartCat.push(cdjDetails)
            stackChartCat.push(['속성', '검색량', '비율'])

            resDataset.push({'sheet_type': 2, 'sheet_nm': '소비자 탐색 인사이트_전체', 'data': stackChartData, 'cat': stackChartCat})
        }

        const response = await CisInsightService.getInsightDataUpperTableExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],          
            cdj : 'total'
        }, source);

        if (response && response.status === 200) {
            var topRankKeywords = [];

            for(const item of response.data.data) {
                topRankKeywords.push({
                    keyword: item.keyword,
                    freq: item.frequency.trim(),
                    brand: item.brand
                });
            }

            resDataset.push({'sheet_type': 3, 'sheet_nm': '검색량 상위 키워드_전체', 'data': topRankKeywords, 'cat': ['검색량', '브랜드']})
        }

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                var cdj_tb_data = null;

                const cdj_tb_resp = await CisInsightService.getInsightDataCDJTable({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],
                    selMiddle: null, 
                }, source);

                if (cdj_tb_resp && cdj_tb_resp.status === 200) {
                    cdj_tb_data = cdj_tb_resp.data.data;

                    var brandFreqData = [];       

                    var gen_search_freq_upper = Math.round((cdj_tb_data[0].freq + cdj_tb_data[1].freq + cdj_tb_data[2].freq)*100)/100

                    brandFreqData.push({
                        cdj: '카테고리 탐색',
                        freq: gen_search_freq_upper
                    })

                    var atr_search_freq_upper = Math.round((cdj_tb_data[3].freq + cdj_tb_data[4].freq + cdj_tb_data[5].freq + cdj_tb_data[6].freq + cdj_tb_data[7].freq)*100)/100

                    brandFreqData.push({
                        cdj: '속성 탐색',
                        freq: atr_search_freq_upper
                    })

                    var buy_manage_freq_upper = Math.round((cdj_tb_data[8].freq + cdj_tb_data[9].freq)*100)/100

                    brandFreqData.push({
                        cdj: '구매 및 관리',
                        freq: buy_manage_freq_upper
                    })

                    var tot_search_freq_upper = Math.round((cdj_tb_data[0].freq + cdj_tb_data[1].freq + cdj_tb_data[2].freq + cdj_tb_data[3].freq + cdj_tb_data[4].freq + cdj_tb_data[5].freq + cdj_tb_data[6].freq + cdj_tb_data[7].freq + cdj_tb_data[8].freq + cdj_tb_data[9].freq)*100)/100

                    brandFreqData.push({
                        cdj: 'Total',
                        freq: tot_search_freq_upper
                    })

                    resDataset.push({'sheet_type': 0, 'sheet_nm': `소비자 탐색 오버뷰_${major.title}`, 'data': brandFreqData, 'cat': ['검색량', '비율']})
                }

                for (const cdj of cdj_list) {
                    const overview_resp = await CisInsightService.getInsightDataDonutBar({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        brandList : [],
                        firstClassList : [major.id],       
                        cdj : cdj
                    }, source);

                    if (overview_resp && overview_resp.status === 200) {
                        const totalFreq = overview_resp.data.data.donutData[0].totalFreq
                        var brandShareData = [];

                        for(const item of overview_resp.data.data.barData) {
                            brandShareData.push({
                                keyword: item.brand,
                                freq: item.freq,
                                rate: totalFreq == 0 ? 0 : item.freq / totalFreq * 100
                            });
                        }

                        resDataset.push({'sheet_type': 1, 'sheet_nm': `브랜드 점유율(${cdj})_${major.title}`, 'data': brandShareData, 'cat': ['검색량', '비율']})
                    }
                }

                // stacked chart category setting
                var cdjDetails = []

                for(const item of cdj_tb_data)
                    cdjDetails.push(item.cdjDetails)

                const stacked_resp = await CisInsightService.getInsightDataStacked({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],
                    selMiddle: null, 
                    cdjDetail1 :  cdjDetails[0],
                    cdjDetail2 :  cdjDetails[1],
                    cdjDetail3 :  cdjDetails[2],
                    cdjDetail4 :  cdjDetails[3],
                    cdjDetail5 :  cdjDetails[4],
                    cdjDetail6 :  cdjDetails[5],
                    cdjDetail7 :  cdjDetails[6],
                    cdjDetail8 :  cdjDetails[7],
                    cdjDetail9 :  cdjDetails[8],
                    cdjDetail10 : cdjDetails[9]
                }, source);

                if (stacked_resp && stacked_resp.status === 200) {
                    // stacked chart update
                    var stackChartData = []
                    var stackChartCat = []
                    var stackDatas = []

                    for(const item of stacked_resp.data.data) {
                        var keywords = item.keyword.split(',')
                        var freqs = item.freq.split(',')
                        var rates = item.rate.split(',')

                        stackDatas = []
                        stackDatas.push(keywords)
                        stackDatas.push(freqs)
                        stackDatas.push(rates)

                        stackChartData.push(stackDatas)
                    }

                    stackChartCat.push(cdjDetails)
                    stackChartCat.push(['속성', '검색량', '비율'])

                    resDataset.push({'sheet_type': 2, 'sheet_nm': `소비자 탐색 인사이트_${major.title}`, 'data': stackChartData, 'cat': stackChartCat})
                }

                const response = await CisInsightService.getInsightDataUpperTableExp({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],          
                    cdj : 'total'
                }, source);

                if (response && response.status === 200) {
                    var topRankKeywords = [];

                    for(const item of response.data.data) {
                        topRankKeywords.push({
                            keyword: item.keyword,
                            freq: item.frequency.trim(),
                            brand: item.brand
                        });
                    }

                    resDataset.push({'sheet_type': 3, 'sheet_nm': `검색량 상위 키워드_${major.title}`, 'data': topRankKeywords, 'cat': ['검색량', '브랜드']})
                }
            }
        }

        return resDataset
    }
}